/**
 * Envío PJ-2 · utilidades puras de la Biblioteca y de «Personalización del
 * proyecto» (con test propio).
 */

const norm = (t) => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

/** Busca por nombre o @ sin importar tildes ni mayúsculas. */
export const matchesQuery = (item, query) => {
  const q = norm(query).trim().replace(/^@/, '');
  if (!q) return true;
  return norm(item?.name).includes(q) || norm(item?.handle).includes(q);
};

export const libraryCounts = (data) => ({
  personajes: Array.isArray(data?.personajes) ? data.personajes.length : null,
  marcas: Array.isArray(data?.marcas) ? data.marcas.length : null,
});

/** «en este proyecto · 3 proyectos», «sin usar»… */
export const usageText = (count, inProject, kind = 'marca') => {
  const n = Number(count) || 0;
  const here = inProject ? (kind === 'reparto' ? 'en el reparto' : 'en este proyecto') : null;
  const total = n ? `${n} proyecto${n === 1 ? '' : 's'}` : null;
  if (here && total) return `${here} · ${total}`;
  return here || total || 'sin usar';
};

/** Filas de «Personalización del proyecto» a partir de la respuesta del servidor. */
export const personalizationRows = (p) => {
  const cast = p?.cast || [];
  const names = cast.map((c) => c.name);
  return [
    { key: 'marca', label: 'Marca', target: 'biblioteca', tab: 'marcas',
      value: p?.brand ? `@${p.brand.handle}` : (p?.no_brand ? 'Ninguna' : 'Sin asignar'),
      empty: !p?.brand },
    { key: 'reparto', label: 'Reparto', target: 'biblioteca', tab: 'personajes',
      value: names.length ? (names.length > 2 ? `${names.slice(0, 2).join(', ')} +${names.length - 2}` : names.join(', ')) : 'Sin personajes',
      empty: !names.length },
    { key: 'plantilla', label: 'Plantilla', target: 'plantillas',
      value: p?.template?.name || 'Ninguna',
      empty: !p?.template || !!p?.template?.missing },
  ];
};
